import React from "react";
import TradingHours from "../../../sections/BusinessDashboard/Settings/TradingHours";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Tradinghours = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Trading hours
      </AdminPageTitle>
      <div className="min-h-screen">
        <TradingHours />
      </div>
    </DashboardMainContainer>
  );
};

export default Tradinghours;
